import React, { useState } from 'react';

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: 'What services does FURNIFLEX provide?',
      answer: 'FURNIFLEX offers comprehensive property management services including tenant screening, guaranteed rent programs, regular property inspections, timely maintenance, value enhancement strategies, and professional management services to ensure your property investment is worry-free and profitable.'
    },
    {
      question: 'How does the guaranteed rent program work?',
      answer: 'Our guaranteed rent program ensures you receive your rent payments on time, regardless of occupancy status. We handle all tenant-related matters and guarantee a steady income stream for property owners, providing financial peace of mind.'
    },
    {
      question: 'What are your management fees?',
      answer: 'Our fees are competitive and transparent offerings are tailored to fit any property portfolio. Contact us for a personalized quote based on your specific property needs and requirements.'
    },
    {
      question: 'How do you screen tenants?',
      answer: 'We conduct thorough tenant screening including credit checks, employment verification, rental history review, and background checks to ensure we place qualified, reliable tenants in your property.'
    },
    {
      question: 'How often do you inspect properties?',
      answer: 'We perform regular inspections on a quarterly basis, with additional inspections available upon request or in case of emergencies. All inspections are documented and reported to property owners.'
    },
    {
      question: 'What happens if there is a maintenance issue?',
      answer: 'We have a network of trusted, licensed contractors who respond promptly to maintenance requests. All maintenance issues are handled efficiently, with property owners kept informed throughout the process. Emergency repairs are addressed immediately.'
    },
    {
      question: 'Can I terminate the management agreement?',
      answer: 'Yes, our management agreements include termination clauses. Please refer to your specific contract or contact us to discuss termination terms and ensure a smooth transition.'
    },
    {
      question: 'How do you enhance property value?',
      answer: 'We implement strategic improvements, regular maintenance, and market analysis to enhance your property\'s value over time. This includes recommendations for upgrades, energy efficiency improvements, and cosmetic enhancements that increase rental income and property valuation.'
    }
  ];

  return (
    <section className="bg-[#FAFAFA] py-16 md:py-24 px-4 md:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="text-gray-400"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M12 16v-4" />
              <path d="M12 8h.01" />
            </svg>
            <span className="text-sm md:text-base text-gray-500 uppercase tracking-wide font-medium">
              FAQs
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 uppercase mb-4">
            Frequently Asked Questions
          </h2>
          <div className="w-16 h-0.5 bg-gray-900 mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-gray-700">
            Find answers to common questions about our property management services
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors"
              >
                <span className="text-lg font-bold text-gray-900 pr-8">
                  {faq.question}
                </span>
                <span className="text-2xl text-gray-600 font-light flex-shrink-0">
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <div className="pt-4 border-t border-gray-100">
                    <p className="text-base text-gray-700 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQs;

